// extracted by mini-css-extract-plugin
export default {"cardContainer":"styles_cardContainer__IIMy1","cardImgWrapper":"styles_cardImgWrapper__SrhEv","cardContent":"styles_cardContent__zh+-8","segmentTitle":"styles_segmentTitle__MyRHV"};